import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Box, Text, Portal } from '../../Boneyard';
import { withValue } from '@g4/automation-hooks';

import closeIconDefault from '../../../images/ic-close-blue.svg';
import { hook } from '@g4/automation-hooks';

const Overlay = styled(Box)`
  position: fixed;
  display: flex;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  overflow-y: scroll;
`;

const ModalWrapper = styled(Box)`
  position: relative;
  margin: 60px 0;
  background: ${props =>
    props.isMobile ? props.theme.colors.common.light : 'rgb(240, 240, 240)'};
  width: ${props => (props.isMobile ? '90%' : 'auto')};
  padding: ${props => (props.isMobile ? '10px' : '25px')};

  &:has(.global-error-wrapper) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  min-width: ${props => (props.isMobile ? '90%' : '400px')};
`;

const ModalHeader = styled(Box)`
  text-align: center;
  padding-bottom: 5px;
  ${props => props.theme.query.md} {
    text-align: ${props => props.titleAlign};
  }
`;

const CloseIcon = styled.button`
  position: absolute;
  z-index: 1;
  top: 15px;
  right: 15px;
  height: 24px;
  width: 24px;
  ${props => props.theme.query.lg} {
    top: 25px;
    right: 25px;
  }
`;

const ModalBody = styled(Box)`
  padding: 10px;
  height: 100%;
`;

const ModalHeaderTitle = styled(Text)`
  padding-top: ${props => (props.isMobile ? '40px' : '0')};
`;

const Modal = ({
  showModal,
  logo,
  title,
  titleAlign,
  automationHook,
  unSetModal,
  isMobile,
  theme,
  children,
  closeIconPath,
}) => {
  if (!showModal) {
    return null;
  }

  return (
    <Portal>
      <Overlay justifyContent={'center'} alignItems={'baseline'}>
        <InnerWrapper>
          <ModalWrapper isMobile={isMobile} borderRadius={8}>
            <ModalHeader>
              {logo && <Box>{logo}</Box>}
              <ModalHeaderTitle
                isMobile={isMobile}
                size={24}
                color={theme.colors.common.peacockBlue}
                weight={isMobile ? 600 : 500}
                automationHook={withValue(automationHook, 'modal-title')}
              >
                {title}
              </ModalHeaderTitle>
              <CloseIcon
                onClick={unSetModal}
                {...hook(withValue(automationHook, 'modal-close'))}
              >
                <img alt="closeIcon" src={closeIconPath} />
              </CloseIcon>
            </ModalHeader>
            <ModalBody justifyContent={'center'} alignItems={'center'}>
              {children}
            </ModalBody>
          </ModalWrapper>
        </InnerWrapper>
      </Overlay>
    </Portal>
  );
};

Modal.propTypes = {
  showModal: PropTypes.bool,
  unSetModal: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleAlign: PropTypes.oneOf(['left', 'center']),
  automationHook: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  children: PropTypes.node,
  closeIconPath: PropTypes.string,
  logo: PropTypes.object,
};

Modal.defaultProps = {
  showModal: false,
  title: 'Enter a Title',
  titleAlign: 'center',
  isMobile: false,
  closeIconPath: closeIconDefault,
};

export default withTheme(Modal);
